import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'libero-new-regular-withdrawal-modal',
  templateUrl: './new-regular-withdrawal-modal.component.html',
  styleUrl: './new-regular-withdrawal-modal.component.scss',
  standalone: false,
})
export class NewRegularWithdrawalModalComponent {
  @Input() public show: boolean | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();

  public constructor(
    public modalService: ModalService,
  ) {}

  public onContinueBtnClick(): void {
    this.continueBtnClick.emit();
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }
}
